/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `2k` - 2k
 * `1080p` - 1080p
 */
export type ResolutionEnum =
  (typeof ResolutionEnum)[keyof typeof ResolutionEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResolutionEnum = {
  "2k": "2k",
  "1080p": "1080p",
} as const;
